import React, { memo, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { MenuLink } from "./header.style";
import { MenuType } from "./typing";
import Button from "@mui/material/Button";
import "./style.scss";
import { Container } from "@mui/material";
import { useDispatch } from "react-redux";

import { useTheme } from "@mui/material";

import { useLocation } from "react-router";
import { TypesAction } from "../../redux/typesAction";

import Search from "./Seach";

const MenuMain: React.FC<{ pages: Array<MenuType> }> = ({ pages }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("");

  const theme = useTheme();

  useEffect(() => {
    const path = location.pathname;
    setActiveLink(path);
  }, [location.pathname]);

  const menuOnPress = (page: MenuType) => {
    if (page.id === 3 || page.id === 4) {
      dispatch({
        type: TypesAction.CATEGORY_ID,
        payload: page.id === 3 ? 1 : 2,
      });
      dispatch({ type: TypesAction.SHOW_INPUT_SEARCH, payload: true });
    } else {
      dispatch({ type: TypesAction.SHOW_INPUT_SEARCH, payload: false });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <Container>
      <Box
        sx={{
          display: {
            xs: "none",
            md: "flex",
            gap: "30px",
            alignItems: "center",
          },
        }}>
        {pages?.map((page) => (
          <MenuLink key={page.id} to={page.link}>
            <Button
              className="btn-appbar"
              onClick={() => menuOnPress(page)}
              sx={{
                my: 2,
                color:
                  activeLink === page.link
                    ? "#007F18"
                    : ` ${theme.palette.text.body}`,
                minWidth: 120,
                py: "7px",
                fontSize: 15,
                fontWeight: 700,
                display: "block",
              }}>
              {page.title}
            </Button>
          </MenuLink>
        ))}

        <Box>
          {location.pathname === "/products-plants" ||
          location.pathname === "/products-pots" ||
          location.pathname === "/order-history" ? (
            <Search />
          ) : (
            <Box sx={{ width: "180px " }}></Box>
          )}
        </Box>
      </Box>
    </Container>
  );
};
export default memo(MenuMain);
